import { WizardVertical } from "./WizardVertical";

type StepStatus = React.ComponentProps<
  typeof WizardVertical
>["steps"][number]["status"];

/**
 * Helper function for the `WizardVertical` component.
 * @param currentStep - active step of the WizardVertical
 * @param targetStep - the step you want to know the status for
 * @returns the corresponding status for the targetStep based on the current one
 */
export function statusForWizardVerticalStep(
  currentStep: number,
  targetStep: number
): StepStatus {
  if (currentStep === targetStep) {
    return "CURRENT";
  }
  return currentStep < targetStep ? "FUTURE" : "COMPLETED";
}
